const elementsWithCondition = document.querySelectorAll('[data-displaycond]');

elementsWithCondition.forEach(function (elementWithCondition) {
	const displaycond = elementWithCondition.dataset.displaycond;
	const displayFieldTrigger = document.getElementById(displaycond);

	const elements = document.querySelectorAll('[name="' + displayFieldTrigger.getAttribute('name') + '"]');

	elements.forEach(function (element) {
		if (!element.classList.contains('display-cond-trigger')) {
			element.classList.add('display-cond-trigger');
		}
	});
})

var hiddenFields = document.querySelectorAll('.hidden');
hiddenFields.forEach(function (hiddenField) {
	if (hiddenField.querySelector('input').getAttribute('required')) {
		hiddenField.querySelector('input').removeAttribute('required');
		hiddenField.querySelector('input').classList.add('required');
	}
})

const triggerElements = document.querySelectorAll('.display-cond-trigger');

triggerElements.forEach(function (triggerElement) {
	const elements = document.querySelectorAll('[name="' + triggerElement.getAttribute('name') + '"]');
	const visibilityContainers = document.querySelectorAll('[data-displaycond="' + triggerElement.getAttribute('id') + '"]');
	triggerElement.addEventListener('change', function() {
		requiredHiddenFields = document.querySelectorAll('.required');

		if(visibilityContainers.length > 0) {
			visibilityContainers.forEach(function (visibilityContainer) {
				if (visibilityContainer.classList.contains('hidden')) {
					visibilityContainer.classList.add('visible');
					visibilityContainer.classList.remove('hidden');
					document.querySelectorAll('.required')
					requiredHiddenFields.forEach(function (requiredHiddenField){
						requiredHiddenField.setAttribute('required', 'required');
					})
				} else {
					visibilityContainer.classList.remove('visible');
					visibilityContainer.classList.add('hidden');
					requiredHiddenFields.forEach(function (requiredHiddenField){
						requiredHiddenField.removeAttribute('required');
					})
				}
			})
		}

		// bei Mehrfachauswahl andere Container wieder deaktiveren
		if(elements.length > 1) {
			elements.forEach(function(element) {
				if(element.getAttribute('type') === 'radio') {
					// const elementContainer = document.querySelector('#' + element.getAttribute('aria-controls'));
					const elementContainers = document.querySelectorAll('[data-displaycond="' + element.getAttribute('id') + '"]');

					if(element.checked === false && elementContainers.length > 0) {
						elementContainers.forEach(function (elementContainer) {
							// elementContainer.classList.remove('form-depending-container--visible');
							elementContainer.classList.remove('visible');
							elementContainer.classList.add('hidden');
							elementContainer.querySelectorAll("[required]");
							elementContainer.querySelector('input').removeAttribute('required');
						})
					}
				}
			});
		}
	});
	if (triggerElement.checked === true) {
		visibilityContainers.forEach(function (visibilityContainer) {
			visibilityContainer.classList.remove('hidden')
			visibilityContainer.classList.add('visible')
		})
	}
});
